<div class="modale opened">
  <div class="modal-main">
    <core-helpers-box-alert-button
    [text]="'Disconnected. Please back to login'"
    [buttonText]="'Go to login'"
    (action)="goToLogin($event)">
    </core-helpers-box-alert-button>
</div>
</div>
